import { z } from 'zod'

export const TermsPendingAccount = z.object({
  account_id: z.number().int(),
  email: z.string(),
  name: z.string(),
  created: z.string().datetime({ offset: true }),
  governing_version: z.string().nullable(),
  accepted_version: z.string().nullable(),
  accepted_at: z.string().datetime({ offset: true }).nullable(),
  notice_sent_at: z.string().datetime({ offset: true }).nullable(),
  days_since_notice: z.number().int().nullable(),
  pending_contracts: z.number().int()
})

export type TermsPendingAccount = z.infer<typeof TermsPendingAccount>

export const TermsPendingList = z.object({
  material_version: z.string().nullable(),
  accounts: z.array(TermsPendingAccount)
})

export type TermsPendingList = z.infer<typeof TermsPendingList>
